.panel {
  background: var(--surface);
  border-radius: var(--radius);
  padding: 24px;
}

.heading {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 12px;
}

.label {
  font-family: var(--font-display);
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text);
}

.note {
  font-size: 0.82rem;
  color: var(--muted);
}

.legend {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 14px;
  margin-bottom: 8px;
}

.legendItem {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  font-weight: 600;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--accent);
}

.legendItem::before {
  content: "";
  flex-shrink: 0;
  width: 10px;
  height: 10px;
  border-radius: 3px;
  background: var(--accent);
}

/* Radar — every athlete overlaid, scaled to a shared max */
.radarWrap {
  display: flex;
  justify-content: center;
  padding: 6px 0 10px;
}

.radar {
  width: 100%;
  max-width: 240px;
  height: auto;
}

.axisLabel {
  font-family: var(--font-sans);
  font-size: 10px;
  font-weight: 600;
  fill: var(--muted);
  transition: fill 0.15s;
}

.axisLabelOn {
  fill: var(--text);
}

.radar polygon[fill="transparent"] {
  cursor: default;
}

@keyframes radarIn {
  from { opacity: 0; transform: scale(0.85); }
  to   { opacity: 1; transform: scale(1); }
}

.poly {
  transform-origin: center;
  animation: radarIn 0.5s cubic-bezier(0.4, 0, 0.2, 1) both;
  animation-delay: calc(var(--i, 0) * 0.08s);
}

/* Per-muscle rows: name + one stacked row per athlete */
.list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.row {
  display: grid;
  grid-template-columns: 86px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  padding: 2px 4px;
  margin: 0 -4px;
  border-radius: 6px;
  cursor: default;
  transition: background 0.15s;
}

.rowOn {
  background: var(--tint);
}

.muscle {
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--soft);
}

.sides {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}

/* Three fixed, right-aligned numeric columns with one shared gap, so %, set
   count and Δ each line up vertically and sit equally spaced like a table. */
.side {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 36px 40px 46px;
  align-items: center;
  gap: 10px;
}

.track {
  height: 8px;
  border-radius: 4px;
  background: var(--tint-md);
  overflow: hidden;
}

.fill {
  height: 100%;
  border-radius: 4px;
  background: var(--accent);
  transition: width 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.pct,
.sets {
  font-size: 0.82rem;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  text-align: right;
  color: var(--accent);
}

.delta {
  font-size: 0.8rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  text-align: left;
}

.delta.up   { color: var(--up); }
.delta.down { color: var(--down); }
.delta.flat { color: var(--muted); }

.tooltip {
  position: fixed;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 2px;
  background: var(--canvas);
  border: 1px solid var(--border-md);
  border-radius: 8px;
  padding: 8px 12px;
  pointer-events: none;
  box-shadow: 0 6px 20px rgba(38, 33, 25, 0.18);
}

.tipLabel {
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--soft);
}

.tipRow {
  font-size: 0.85rem;
  font-variant-numeric: tabular-nums;
  color: var(--accent);
}

.tipDiff {
  font-size: 0.82rem;
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  color: var(--text);
  margin-top: 2px;
  padding-top: 4px;
  border-top: 1px solid var(--border);
}
